import type { LinkProps as RouterLinkProps } from '@takeshape/redux-little-router';
import { assert } from '@takeshape/util';
import { createBranchPath } from 'app/branches/utils';
import { createProjectPath } from 'app/project/utils';
import omit from 'lodash/omit';

export const interpolate = (href: string, args: { projectId?: string; branchName?: string }): string => {
  let result = href;
  if (args.projectId) {
    result = result.replace('{projectPath}', createProjectPath(args.projectId));
  }

  if (args.branchName) {
    assert(args.projectId !== undefined, 'Cannot have link with branch but no project id');
    result = result.replace('{branchPath}', createBranchPath(args.projectId, args.branchName));
  } else if (args.projectId) {
    result = result.replace('{branchPath}', createBranchPath(args.projectId));
  }

  return result;
};

export type LinkHookProps = {
  href: string;
  title?: string;
  projectId?: string;
  branchName?: string;
  children?: React.ReactNode;
  styled?: boolean;
} & RouterLinkProps;

export const useLink = ({ projectId, branchName, href, ...rest }: LinkHookProps) => {
  href = interpolate(href, { projectId, branchName });

  // `dispatch` is occasionally being passed to `a`, causing verbose errors in local dev
  const passthroughProps = omit(rest, ['dispatch']);

  return {
    ...passthroughProps,
    href
  };
};
